import React from 'react'

type LocationMarkerIconProps = {
  fillColor?: string
  ellipseColor?: string
  pathColor?: string
  content: number | string
  className?: string
  baseOpacity?: number //default opacity of the marker until it is hovered
}

export const LocationMarkerIcon: React.FC<LocationMarkerIconProps> = ({
  fillColor = '#000',
  ellipseColor = '#FFF',
  pathColor = '#000',
  content,
  className = '',
  baseOpacity = 1,
  ...props
}) => {
  return (
    <svg
      width="30"
      height="40"
      viewBox="0 0 34 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ opacity: baseOpacity }}
      className={className}
      {...props}
    >
      <defs>
        <filter id="dropshadow" height="130%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2" />
          <feOffset dx="2" dy="2" result="offsetblur" />
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.5" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g filter="url(#dropshadow)">
        <path
          d="M30 15C30 21.8281 20.8594 33.9844 16.8516 39C15.8906 40.1953 14.1094 40.1953 13.1484 39C9.14063 33.9844 0 21.8281 0 15C0 6.71875 6.71875 0 15 0C23.2812 0 30 6.71875 30 15Z"
          fill={fillColor}
        />
        <ellipse
          cx="15"
          cy="15"
          rx="13.125"
          ry="13.0861"
          fill={ellipseColor}
        />
      </g>
      <text
        x="44%"
        y="35%"
        textAnchor="middle"
        dy=".35em"
        fontSize="16"
        fill={pathColor}
        fontWeight="bold"
      >
        {content}
      </text>
    </svg>
  )
}